import { render, staticRenderFns } from "./TopNavExternalRoutes.vue?vue&type=template&id=2a821c0e&scoped=true&"
import script from "./TopNavExternalRoutes.vue?vue&type=script&lang=js&"
export * from "./TopNavExternalRoutes.vue?vue&type=script&lang=js&"
import style0 from "./TopNavExternalRoutes.vue?vue&type=style&index=0&id=2a821c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a821c0e",
  null
  
)

export default component.exports